module.exports = __webpack_public_path__ + "static/media/blog-03.758a35e3.jpg";